export default {
  noutati_label: 'Noutati',
  documente_discutie_label: 'Documente de discutie',
  buletine_informative_label: 'Buletine informative',
  debug_topic_label: 'Debug',
  energie_electrica_label: 'Energie electrica',
  gaze_naturale_label: 'Gaze naturale',
  copyright: 'Toate drepturile rezervate.',
  termeni_si_conditii: 'Termeni si conditii',
  pagina_termeni_si_conditii: 'termeni-si-conditii'
}
